import template from './collected.html';
import controller from './collected.controller';
import './collected.scss';

let CollectedComponent = {
  bindings: {
    collectedObservable: '<'
  },
  template,
  controller
};

export default CollectedComponent;



// WEBPACK FOOTER //
// ./src/app/pages/collected/collected.component.js